import React, { ReactNode } from 'react';
import cn from 'classnames';
import './Progress.scss';

export interface IProgressProps {
    children?: ReactNode,
    className?: string,
}

export function Progress({ children, className }: IProgressProps) {
    return <div className={cn('progress', className)}>
        {children}
    </div>
}